<template>
  <component :is="component" />
</template>

<script>
import invoiceUploadCheck from '../components/invoiceUploadCheck.vue'
import invoiceUpload from '../invoiceUpload.vue'
export default {
  components: {
    invoiceUploadCheck,
    invoiceUpload
  },
  data() {
    return {
      component: 'invoiceUploadCheck'
    }
  },
  created() {
    const { _role } = this.$route.query
    this.component = _role === 'check' ? 'invoiceUploadCheck' : 'invoiceUpload'
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/dealer-manage/check/invoiceUploadCheck.vue